import { convertObjectToSingleString } from '../../../../../utils/helper';
export const getTapLoaderNode = options => ({
  inline: true,
  attrs: {
    id: {
      default: ''
    }
  },
  group: 'inline',
  selectable: false,
  parseDOM: [{
    tag: 'span[data-taploader]',
    getAttrs(dom) {
      return {
        id: dom.getAttribute('data-id')
      };
    }
  }],
  toDOM(node) {
    const {
      id
    } = node.attrs;
    const {
      hasInlineStyles
    } = options;
    let styles;
    if (hasInlineStyles) {
      const tapLoaderStyles = {
        display: 'inline-block',
        height: '1.5rem',
        width: '1.5rem',
        'vertical-align': 'middle',
        'background-repeat': 'no-repeat',
        'background-size': 'contain'
      };
      styles = convertObjectToSingleString(tapLoaderStyles);
    }
    return ['span', {
      'data-taploader': 'true',
      class: 'tap-loader',
      'data-id': id,
      style: styles
    }];
  }
});